/**
 * Клиентская подгрузка staff-модулей страницы ЛПУ.
 *
 * Список совпадает с `webpack-bundles/pd/extensions/staff-modules/lpu-staff.json`.
 * На полной Vue-странице бандл не вешаем в layout: грузим только staff при монтировании
 * `LpuStaffAdmin`, чтобы не тащить jquery-ui всем пользователям.
 */
let loadPromise: Promise<void> | null = null

export default function loadLpuStaffModules(): Promise<void> {
  if (!process.env.IS_CLIENT) {
    return Promise.resolve()
  }

  if (!loadPromise) {
    loadPromise = (async () => {
      await Promise.all([
        // @ts-ignore
        import(/* webpackChunkName: "lpu-staff" */ 'www/js/libs/jqueryui/1.11.0/jquery-ui.min'),
        // @ts-ignore
        import(/* webpackChunkName: "lpu-staff" */ 'www/css/libs/jqueryui/1.11.0/themes/smoothness/jquery-ui.css'),
        // @ts-ignore
        import(/* webpackChunkName: "lpu-staff" */ 'www/library.blocks/common/adminka/adminka.scss'),
        // @ts-ignore
        import(/* webpackChunkName: "lpu-staff" */ 'www/blocks/from_assets.blocks/common/lpu-staff/lpu-staff.scss'),
      ])

      // lpu-staff сразу дергает #widget_panel_container и window.lpu_id / town.
      await import(/* webpackChunkName: "lpu-staff" */ 'www/blocks/from_assets.blocks/common/lpu-staff/lpu-staff')

      await Promise.all([
        // @ts-ignore
        import(/* webpackChunkName: "lpu-staff" */ 'www/blocks/from_assets.blocks/common/staff-image-uploading/staff-image-uploading'),
        import(/* webpackChunkName: "lpu-staff" */ 'www/pult.blocks/common/b-image-editor-custom-event-button/b-image-editor-custom-event-button'),
        import(/* webpackChunkName: "lpu-staff" */ 'www/doctors.blocks/common/b-logo-uploader'),
      ])
    })()
  }

  return loadPromise
}
